/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'plan-supplemental-income-48x48': {
    width: 48,
    height: 48,
    viewBox: '0 0 48 48',
    data: '<g _stroke="currentColor" stroke-width="2" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path pid="0" d="M2 7h7v7M46 41h-7v-7M24 13v2"/><path pid="1" d="M7.737 7.737A22.928 22.928 0 001 24c0 12.703 10.297 23 23 23M40.263 40.263A22.928 22.928 0 0047 24C47 11.297 36.703 1 24 1M18.75 30c0 1.5 2.35 3 5.25 3s5.25-2.015 5.25-4.5S26.625 24.75 24 24s-5.25-2.015-5.25-4.5S21.1 15 24 15s5.25 1.5 5.25 3M24 33v2"/></g>'
  }
})
